import { render, staticRenderFns } from "./GroupInviteLink.vue?vue&type=template&id=0db07d64&scoped=true&"
import script from "./GroupInviteLink.vue?vue&type=script&lang=js&"
export * from "./GroupInviteLink.vue?vue&type=script&lang=js&"
import style0 from "./GroupInviteLink.vue?vue&type=style&index=0&id=0db07d64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db07d64",
  null
  
)

component.options.__file = "GroupInviteLink.vue"
export default component.exports